import Helpers from "../../helpers/helpers";
import { server } from "../globalSettings";

export const requestAuthOption = (method, data) => {
    let isRemember = localStorage.getItem("remember");
    let token = JSON.parse(localStorage.getItem("token"))

    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, },
        };
        return requestOptions
    }

}

export const quotationListingApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}quotations?paginate=${payload?.page || ''}&size=${payload?.length || ''}&sort=${payload?.sort_by || ''}&sort_order=${payload?.sort || ''}&search=${payload?.search || ''}&filter[loan_term]=${payload?.loan_term || ''}&filter[bike_make_ids]=${payload?.bike_make_ids || ''}&filter[bike_model_ids]=${payload?.bike_model_ids || ''}&filter[selling_price_min]=${payload?.selling_price_min || ''}&filter[selling_price_max]=${payload?.selling_price_max || ''}&filter[user_id]=${payload?.user_id || ''}&filter[created_date_from]=${payload?.created_date_from || ''}&filter[created_date_to]=${payload?.created_date_to || ''}&filter[vehicle_type]=${payload?.vehicle_type || ''}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // throw error;
            })
        })
    }
};

export const quotationFiltersApi = async () => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}quotations/filters`, request);
        const data = await response.json();
        if (response.ok) return data;
        if (data?.code === "login_needed" || data?.code === "unauthenticated") Helpers.routeToLogin();
        return Promise.reject(data);
    } catch (error) {
        return Promise.reject({ code: "network_error", message: "Network response error, please try again later" });
    }
};

export const quotationDetailsApi = async (payload) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(
            `${server}quotations/${payload?.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        reject(data)
                        resolve(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(data);

                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // throw error;
            })
        })
    }
};

export const quotationCreateApi = async (payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(
            `${server}quotations`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success" || data.code === "validate_success") {
                        resolve(data);
                    } else {
                        reject(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(data);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // throw error;
            })
        })
    }
};

export const quotationUpdateApi = async (payload) => {
    const request = requestAuthOption("PUT", payload?.data);
    try {
        const response = await fetch(`${server}quotations/${payload?.id}`, request);
        const data = await response.json();
        if (response.ok && data?.code === "success") return data;
        if (data?.code === "login_needed" || data?.code === "unauthenticated") Helpers.routeToLogin();
        return Promise.reject(data);
    } catch (error) {
        return Promise.reject({ code: "network_error", message: "Network response error, please try again later" });
    }
};

export const quotationAdvertListingApi = async (payload) => {
    const params = new URLSearchParams({
        type: "quotation_bike_adverts",
        paginate: payload?.page || 1,
        size: payload?.length || 9,
    });
    if (payload?.search) params.set("search", payload.search);
    if (payload?.make) params.set("filter[bike_make_ids]", payload.make);
    if (payload?.model) params.set("filter[bike_model_ids]", payload.model);
    if (payload?.selectedId !== null && payload?.selectedId !== undefined) {
        params.set("selected_id", payload.selectedId);
    }

    const request = requestAuthOption("GET");
    try {
        const response = await fetch(`${server}general?${params.toString()}`, request);
        const data = await response.json();
        if (response.ok) return data;
        if (data?.code === "login_needed" || data?.code === "unauthenticated") Helpers.routeToLogin();
        return Promise.reject(data);
    } catch (error) {
        return Promise.reject({ code: "network_error", message: "Network response error, please try again later" });
    }
};

export const quotationDeleteApi = async (payload) => {
    const request = requestAuthOption("DELETE")
    try {
        const response = await fetch(
            `${server}quotations/${payload?.id}`,
            request
        );
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else {
                        reject(data)
                    }
                } else {
                    if (data?.code === "login_needed" || data?.code === "unauthenticated") {
                        Helpers.routeToLogin();
                    }
                    reject(data);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject({ code: "network_error", message: "Network response error, please try again later" });
                // throw error;
            })
        })
    }
};

const quotationPostApi = async (url, payload) => {
    const request = requestAuthOption("POST", payload)
    try {
        const response = await fetch(`${server}${url}`, request);
        const data = await response.json();
        if (response.ok && data?.code === "success") return data;
        if (data?.code === "login_needed" || data?.code === "unauthenticated") Helpers.routeToLogin();
        return Promise.reject(data);
    } catch (error) {
        return Promise.reject({ code: "network_error", message: "Network response error, please try again later" });
    }
};

export const quotationCalculateApi = payload => quotationPostApi("quotations/calculate", payload);
const ensureQuotationSent = async (request) => {
    const response = await request;
    return response?.code === "success" ? response : Promise.reject(response);
};
export const quotationEmailApi = payload => ensureQuotationSent(quotationPostApi(`quotations/${payload?.id}/email-pdf`, payload?.data));
export const quotationWhatsappApi = payload => ensureQuotationSent(quotationPostApi(`quotations/${payload?.id}/whatsapp`, payload?.data));
